import { KpiCard } from '../ui/KpiCard';
import { IconVault, IconBuilding, IconLink, IconAlert } from '../ui/icons';

/**
 * Portfolio KPI cards. Values come straight from the backend summary; we never
 * aggregate in the frontend. Renders a placeholder dash while loading.
 * @param {{ summary?: import('../../api/originatorApi').PortfolioSummaryResponse | null,
 *   loading?: boolean }} props
 */
export function PortfolioKpiCards({ summary, loading }) {
  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
      <KpiCard
        label="Total batches"
        value={summary?.total_batches ?? 0}
        subline="Batches in your organization"
        icon={IconBuilding}
        accent
        loading={loading}
      />
      <KpiCard
        label="Total loans"
        value={summary?.total_loans ?? 0}
        subline="Across all access states"
        icon={IconVault}
        loading={loading}
      />
      <KpiCard
        label="Pending authority"
        value={summary?.pending_authority ?? 0}
        subline="Awaiting authority decision"
        icon={IconLink}
        loading={loading}
      />
      <KpiCard
        label="Pending custody"
        value={summary?.pending_custody ?? 0}
        subline="Awaiting custodian action"
        icon={IconAlert}
        loading={loading}
      />
    </div>
  );
}
